"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.VALIDATOR_CLASSES = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _utils = require("../utils/utils");

var _Button = _interopRequireDefault(require("../Button/Button"));

var _caretDown = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/caret-down"));

var _check = _interopRequireDefault(require("@parchment/ui-icons/lib//ai/check-2"));

var _reactBootstrap = require("react-bootstrap");

var _warning = _interopRequireDefault(require("@parchment/ui-icons/lib/ai/warning"));

require("./Dropdown.less");

var _classnames = _interopRequireDefault(require("classnames"));

var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var KEY_UP = 38;
var KEY_DOWN = 40;
var KEY_ENTER = 13;
var KEY_SPACE = 32;
var KEY_ESC = 27;
var VALIDATOR_CLASSES = {
  valid: 'has-success',
  invalid: 'has-error'
};
/**
 * @deprecated This <Dropdown /> component is being replaced with the <Select />
 *             component. Which is mostly compatible. Migration is pretty much
 *             just import the Select and replace "Dropdown" with "Select" and
 *             then you'll probably need to tweak the change event. The change
 *             event was renamed from onHandleChange to onChange. And the value
 *             passed to it is now the entire option object that was selected
 *             instead of the option value
 */

exports.VALIDATOR_CLASSES = VALIDATOR_CLASSES;

var Dropdown = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Dropdown, _Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Dropdown);
    _this = _super.call(this, props);
    _this.state = {
      lastClicked: null,
      title: props.title,
      options: props.options,
      navIndex: _this.getOptionIndex(props.selected || props.options.find(function (opt) {
        return !opt.header && !opt.disabled;
      }), props.options) || 0,
      selected: props.selected,
      expanded: props.expanded,
      isValid: props.required && props.selected !== null,
      touched: props.selected !== null,
      componentId: (0, _utils.generateUUID)()
    };
    _this.handleToggle = _this.handleToggle.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleNavKeyDown = _this.handleNavKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Dropdown, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var nextState = {
        lastClicked: null,
        selected: nextProps.selected
      };

      if (this.isFieldRequired(nextProps)) {
        nextState.isValid = !!nextProps.selected;
      }

      this.setState(nextState);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.lastClicked !== this.state.lastClicked) {
        this.handleClose();
      }

      if (this.state.expanded) {
        (0, _scrollIntoViewIfNeeded.default)(this.selectedNode);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove click event listener on component unmount
      window.removeEventListener('mouseup', this.handleClose);
    }
  }, {
    key: "getOptionIndex",
    value: function getOptionIndex(option) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.options;
      var index = null;

      if (!option) {
        return index;
      }

      options.some(function (opt, i) {
        if (option.id === opt.id) {
          index = i;
          return true;
        }
      });
      return index;
    }
  }, {
    key: "isFieldRequired",
    value: function isFieldRequired() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      return props.required;
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      if (this.props.disabled) {
        return;
      }

      var expanded = this.state.expanded;
      window.addEventListener('mouseup', this.handleClose);
      this.setState({
        expanded: !expanded
      });
    }
  }, {
    key: "handleClose",
    value: function handleClose() {
      window.removeEventListener('mouseup', this.handleClose);
      var nextState = {
        expanded: false,
        touched: true
      };

      if (this.isFieldRequired()) {
        nextState.isValid = !!this.state.selected;
      }

      this.setState(nextState);
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      var _this2 = this;

      window.removeEventListener('mouseup', this.handleClose);
      var options = this.state.options;
      var _this$props = this.props,
          onHandleChange = _this$props.onHandleChange,
          required = _this$props.required;
      var selectedOption = null; //This should always return a value, so being null will not be an issue (except if we show the first option of course)

      if (value !== null) {
        for (var i = 0; i < options.length; i++) {
          if (options[i].id === value) {
            selectedOption = options[i];
            break;
          }
        }
      }

      var nextState = {
        navIndex: this.getOptionIndex(selectedOption),
        selected: selectedOption,
        expanded: false,
        touched: true,
        lastClicked: Date.now()
      };

      if (required) {
        nextState.isValid = value !== null;
      }

      this.setState(nextState, function () {
        if (onHandleChange && typeof onHandleChange === 'function' && onHandleChange !== _utils.noop) {
          /*
          TODO(?):
          At some point we may want to also return whether the component is valid, this way if its a form field and there is some action to be taken
          based on whether this is valid, at least the parent would know if its valid. Doing this right now would break current functionality
          */
          onHandleChange(_this2.state.selected ? _this2.state.selected.id : null);
        }
      });
    }
  }, {
    key: "handleNavKeyDown",
    value: function handleNavKeyDown(e) {
      var _this$state = this.state,
          navIndex = _this$state.navIndex,
          options = _this$state.options,
          expanded = _this$state.expanded;
      var offset = e.which === KEY_DOWN ? 1 : e.which === KEY_UP ? -1 : 0;

      if (expanded && offset) {
        this.handleNavOffset(offset);
        e.preventDefault();
        return false;
      } else if (expanded && [KEY_ENTER, KEY_SPACE].indexOf(e.which) >= 0) {
        // when expanded and we press spacebar or enter, we want to select
        // the currently highlighted option
        this.handleChange(options[navIndex].id);
        e.preventDefault();
        return false;
      } else if (!expanded && e.which === KEY_SPACE || expanded && e.which === KEY_ESC) {
        // toggle the menu if its not expanded and we pressed the spacebar
        // ... or it is currently expanded and we pressed esc
        this.handleToggle();
        e.preventDefault();
        return false;
      }
    }
  }, {
    key: "handleNavOffset",
    value: function handleNavOffset(offset) {
      var _this$state2 = this.state,
          navIndex = _this$state2.navIndex,
          options = _this$state2.options; // we're expanded and we navigating up or down

      var min = 0; // Math.max, to ensure max is never less than 0

      var max = Math.max(options.length - 1, 0);
      var nextIndex = navIndex;
      var option;
      var selectable; // loop through finding the next selectable element (if possible)

      do {
        nextIndex = nextIndex + offset;

        if (nextIndex < min || nextIndex > max) {
          // outside the range, reset to the current one
          nextIndex = navIndex;
          break;
        }

        option = options[nextIndex];
        selectable = !option.header && !option.disabled;
      } while (!selectable);

      this.setState({
        navIndex: nextIndex
      });
    }
  }, {
    key: "getValidityIcon",
    value: function getValidityIcon() {
      var iconContent = null;

      if (this.props.required && this.state.touched) {
        iconContent = this.state.isValid ? /*#__PURE__*/_react.default.createElement(_check.default, {
          className: "state-icon"
        }) : /*#__PURE__*/_react.default.createElement(_warning.default, {
          className: "state-icon"
        });
      }

      return iconContent;
    }
  }, {
    key: "getOptionText",
    value: function getOptionText(text, required) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "option-text"
      }, required ? /*#__PURE__*/_react.default.createElement("span", {
        className: "text-danger"
      }, "* ") : '', /*#__PURE__*/_react.default.createElement("span", null, text));
    }
  }, {
    key: "renderErrorToolTip",
    value: function renderErrorToolTip() {
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Overlay, {
        className: "error-overlay",
        show: this.state.isValid === false && this.state.touched && !this.state.expanded,
        container: this,
        placement: "top"
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Popover, {
        className: "error-tooltip",
        id: "error-tooltip-for-".concat(this.props.errorTitle),
        placement: "top",
        title: this.props.errorTitle ? this.props.errorTitle : 'error'
      }, this.props.errorMessage));
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var _this$state3 = this.state,
          options = _this$state3.options,
          navIndex = _this$state3.navIndex,
          selected = _this$state3.selected,
          title = _this$state3.title,
          expanded = _this$state3.expanded,
          componentId = _this$state3.componentId,
          isValid = _this$state3.isValid,
          touched = _this$state3.touched;
      var _this$props2 = this.props,
          size = _this$props2.size,
          block = _this$props2.block,
          className = _this$props2.className,
          showFirstOption = _this$props2.showFirstOption,
          required = _this$props2.required,
          disabled = _this$props2.disabled;
      var dropDownWrapperProps = Object.assign({}, {
        'id': 'dropdown-' + componentId,
        'className': (0, _classnames.default)('primitive-dropdown', {
          'expanded': expanded,
          'block': block
        }, (_classNames = {}, (0, _defineProperty2.default)(_classNames, size, size), (0, _defineProperty2.default)(_classNames, className, className), (0, _defineProperty2.default)(_classNames, VALIDATOR_CLASSES.valid, required && touched && isValid), (0, _defineProperty2.default)(_classNames, VALIDATOR_CLASSES.invalid, required && touched && !isValid), _classNames))
      });
      var buttonProps = Object.assign({}, {
        'className': (0, _classnames.default)('white hollow dropdown-trigger', {
          'active': expanded
        }, (0, _defineProperty2.default)({}, className, className)),
        'aria-haspopup': true,
        'aria-expanded': expanded,
        'size': size ? size : undefined,
        'block': block,
        'disabled': !!disabled,
        'onSubmit': function onSubmit() {
          _this3.handleToggle();
        },
        'type': 'button'
      });
      var selectedLabel = title;
      var selectedOptionRequired = false;

      if (selected) {
        selectedLabel = selected.description;
        selectedOptionRequired = selected.required;
      }

      var viewOptions = options.slice(); //If there is a first option, add this as the first item

      if (showFirstOption) {
        viewOptions.unshift({
          id: null,
          description: title,
          header: true
        });
      }

      return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, dropDownWrapperProps, {
        onKeyDown: this.handleNavKeyDown
      }), /*#__PURE__*/_react.default.createElement(_Button.default, buttonProps, this.getValidityIcon(), this.getOptionText(selectedLabel, selectedOptionRequired), /*#__PURE__*/_react.default.createElement("span", {
        className: "caret-handle"
      }, /*#__PURE__*/_react.default.createElement(_caretDown.default, null))), this.props.errorToolTip && this.renderErrorToolTip(), /*#__PURE__*/_react.default.createElement("ul", {
        "aria-labelledby": "dropdownMenu-".concat(componentId),
        role: "menu",
        className: "menu-dropdown"
      }, viewOptions.map(function (option, index) {
        var selected = index === navIndex;
        var itemProps = {
          key: index,
          role: 'presentation',
          className: (0, _classnames.default)({
            header: option.header,
            divider: option.divider,
            disabled: option.disabled,
            selected: selected
          })
        }; //None of these should be clickable, so don't bind the call back on these

        if (!option.header && !option.disabled) {
          itemProps.onClick = function () {
            _this3.handleChange(option.id);
          };

          itemProps.onMouseEnter = function () {
            return _this3.setState({
              navIndex: index
            });
          };
        }

        if (selected) {
          itemProps.ref = function (node) {
            return _this3.selectedNode = node;
          };
        }

        return /*#__PURE__*/_react.default.createElement("li", (0, _extends2.default)({
          key: index
        }, itemProps), _this3.getOptionText(option.description, option.required));
      })));
    }
  }], [{
    key: "propTypes",
    value: function propTypes() {
      return {
        title: _propTypes.default.string,
        options: _propTypes.default.array,
        size: _propTypes.default.oneOf(['smallest', 'small', '', 'large']),
        className: _propTypes.default.string,
        expanded: _propTypes.default.bool,
        block: _propTypes.default.bool,
        disabled: _propTypes.default.bool,
        required: _propTypes.default.bool,
        errorToolTip: _propTypes.default.bool,
        errorMessage: _propTypes.default.string,
        errorTitle: _propTypes.default.string,
        showFirstOption: _propTypes.default.bool,
        onHandleChange: _propTypes.default.func
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        title: 'Select An Option',
        options: [],
        selected: null,
        size: '',
        className: '',
        block: false,
        expanded: false,
        disabled: false,
        required: false,
        errorToolTip: false,
        showFirstOption: false,
        onHandleChange: _utils.noop
      };
    }
  }]);
  return Dropdown;
}(_react.Component);

exports.default = Dropdown;